import { render, staticRenderFns } from "./ReactionsList.vue?vue&type=template&id=3e7844c1&scoped=true"
import script from "./ReactionsList.vue?vue&type=script&lang=js"
export * from "./ReactionsList.vue?vue&type=script&lang=js"
import style0 from "./ReactionsList.vue?vue&type=style&index=0&id=3e7844c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7844c1",
  null
  
)

export default component.exports